export default __webpack_public_path__ + "static/media/sombra-celular.d6b689de.png";